import React from 'react';
import { GateSchedule } from 'types/Gates';
import { useRegion } from 'common/hooks/region';
import { Shift } from 'types/Port';
import GateScheduleTableHeader from './GateScheduleTableHeader';
import GateScheduleTableRowCell from './GateScheduleTableRowCell';
import GateScheduleTableHeaderCell from './GateScheduleTableHeaderCell';
import GateScheduleService from './services/gate-schedule.service';

interface Props {
  tableId: string;
  tableData?: GateSchedule;
  isFetching?: boolean;
  error?: unknown;
  isNextWeek?: boolean;
  onDownloadClick: (isNextWeek?: boolean) => void;
}

interface RowProp {
  terminal: string;
  data: string[];
}

const GateScheduleTable: React.FC<Props> = (props) => {
  const { tableId, tableData, isFetching, error, isNextWeek, onDownloadClick } = props;
  const region = useRegion();

  const singleShift = region.shifts.length === 1;

  return (
    <div id={tableId} className={`gate-schedule-table-wrapper${isNextWeek ? '' : ' current'}`}>
      <GateScheduleTableHeader
        lastUpdate={tableData?.last_update || null}
        isNextWeek={isNextWeek}
        onDownloadClick={onDownloadClick}
        isFetching={isFetching}
        hasData={!!tableData}
      />
      {error ? (
        <h3>Could not fetch {isNextWeek ? 'next' : 'this'} week&apos;s gate schedule</h3>
      ) : null}
      {tableData && (
        <div className="gate-schedule-table">
          <div className="gate-schedule-table-header">
            <div className="gate-schedule-table-header-cell terminal-name">Terminal</div>
            {tableData.headers &&
              tableData.headers.map(({ date, shift }, index) => {
                if (!region.shifts.includes(`shift${shift}` as Shift)) {
                  return null;
                }
                const isToday = GateScheduleService.checkIsDateToday(date);
                return (
                  <GateScheduleTableHeaderCell
                    // TODO: Discuss our options for keys
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    date={date}
                    shift={singleShift ? undefined : shift}
                    isToday={isToday}
                  />
                );
              })}
          </div>
          <div className="gate-schedule-table-body">
            {tableData.data &&
              tableData.data.map((rowProp: RowProp) => (
                <div key={rowProp.terminal} className="gate-schedule-table-body-row">
                  <div className="gate-schedule-table-body-row-cell terminal-name">
                    {rowProp.terminal}
                  </div>
                  {rowProp.data &&
                    rowProp.data.map((status: string, index: number) => {
                      const shift = (index % 3) + 1;
                      if (!region.shifts.includes(`shift${shift}` as Shift)) {
                        return null;
                      }

                      const { date } = tableData.headers[index] || {};
                      const isToday = GateScheduleService.checkIsDateToday(date);
                      return (
                        <GateScheduleTableRowCell
                          // TODO: Discuss our options for keys
                          // eslint-disable-next-line react/no-array-index-key
                          key={index}
                          status={status}
                          isToday={isToday}
                        />
                      );
                    })}
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};
GateScheduleTable.displayName = 'GateScheduleTable';

export default GateScheduleTable;
